import Button from '@/components/common/Button';
import React, { ReactNode } from 'react';
import styles from '../styles.module.css';
import { useTranslations } from 'next-intl';
import { mouseEvent, onClickHandle, productCardType } from '@/commonTypes';
import { useLayoutContext } from '@/context/LayoutContext';
import { TRIGGERS } from '@/api/global';
import MainIcons from '@/icons/main';
import Api from '@/api';

export default function AddToCartButton({
  show = true,
  item,
  relative = false,
  productCount = 1,
  children,
  parentClassName = '',
  text = 'افزودن',
  icon,
  className = '',
}: {
  show?: boolean;
  item?: productCardType;
  relative?: boolean;
  productCount?: number;
  children?: ReactNode;
  parentClassName?: string;
  text?: string;
  icon?: ReactNode;
  className?: string;
}) {
  const tCommon = useTranslations('common');
  const {
    basket,
    setBasket,
    setTrigger,
    checkIfLogin,
    loadingBasket,
    setLoadingBasket,
    isLogin,
    generateBasketObject,
    showError,
  } = useLayoutContext();
  console.log('isLogin====', isLogin);
  const AddToCartFunction = (e: mouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    const basketItems = generateBasketObject(item);
    console.log('basketItems==', basketItems);
    let basketDummy = basket ? basket : [];
    if (isLogin) {
      let quantity = productCount;
      const index = basketDummy?.findIndex((x) => x.id == item?.id);
      if (index != -1) {
        quantity = Number(basketDummy?.[index]?.count) + productCount;
      }
      item?.id && setLoadingBasket(item?.id);
      Api.addEditCart({
        productId: item?.id,
        quantity: quantity,
      })
        .then((res) => {
          setTrigger(TRIGGERS.BASKETMODAL);
        })
        .catch((err) => {
          setLoadingBasket(false);
          showError(err);
        });
    } else {
      let newarray = [...basketDummy];
      let index = basketDummy?.findIndex((x) => x.id == item?.id);

      if (index != -1) {
        let count;
        if (newarray[index].count) {
          count = Number(newarray[index].count) + productCount;
        }
        newarray[index].count = count;
        setBasket(newarray);
      } else {
        setBasket([...basketDummy, { ...basketItems, count: productCount }]);
      }
      setTrigger(TRIGGERS.BASKETMODAL);
    }
    // setServerMessage && setServerMessage({ type: 'success', text: tCommon('addedToBasket') });
  };

  return (
    <Button
      className={`${styles.addButton} ${show && styles.show} ${relative && styles.relativeButton} ${className}`}
      // onClick={(e) => {
      //   checkIfLogin &&
      //     checkIfLogin((e: mouseEvent) => {
      //       AddToCartFunction(e);
      //     });
      // }}
      onClick={(e) => {
        // checkIfLogin?.(() => {
        AddToCartFunction(e);
        // }, e);
      }}
      loading={loadingBasket == item?.id ? true : false}
      wrapperStyle={`${styles.parentAddButtonClass} ${parentClassName}`}
    >
      {icon ? icon : <MainIcons.plusIcon fill="var(--paper)" width="16px" height="16px" />}
      <div className={`${styles.addtocarttextPart}`}>
        {text} {children}
      </div>
    </Button>
  );
}
